import { render, staticRenderFns } from "./AppMenuIcon.vue?vue&type=template&id=e7078f90&scoped=true"
import script from "./AppMenuIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuIcon.vue?vue&type=style&index=0&id=e7078f90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7078f90",
  null
  
)

export default component.exports